module.exports = __webpack_public_path__ + "src/assets/games/14/326.jpg";